export const CommonConstant = {
    token: 'token',
    guestToken: 'guestToken',
    user: 'user',
    orgCode: 'orgCode',
    school: 'school',
    schoolName: 'schoolName',
    employeeName: 'employeeName',
    employeeId: 'employeeId',
    studentName: 'studentName',
    studentProfileId: 'studentProfileId',
    appName: 'appName',
    userName: 'userName',
    supportSessionId: 'supportSessionId',
    supportSession: 'supportSession',
    supportMetadata: 'supportMetadata',
    impersonatedSchool: 'impersonatedSchool',
    parentSession: 'admissionsParentSession',
};
